<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-btn
          :to="`/users/project/${$route.params.id}/groups/create`"
          light
          color="amber"
          class="mt-5 mb-5"
          >Add Group</v-btn
        ></v-col
      >
      <v-col cols="4" v-for="item in items" :key="item.id">
        <v-card light height="100%">
          <v-card-title>
            <h3 class="overline">{{ item.doc.name }}</h3>
          </v-card-title>

          <v-card-text>
            <p>{{ item.doc.description }}</p>
          </v-card-text>
          <v-card-actions>
            <v-btn light color="amber" class="mb-2" @click="editCard(item.id)"
              >Edit</v-btn
            >
            <v-btn
              light
              color="amber"
              class="mb-2"
              @click="deleteRequest(item.id)"
              >Delete</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <bottom-navigation
      :save="false"
      :next="false"
      :prev="false"
      :list="`groups`"
      :gridView="false"
      :gridToggle="false"
    >
    </bottom-navigation>

    <v-dialog v-model="dialog" max-width="800">
      <v-card>
        <v-card-title class="headline"
          >Are you sure you want to delete this?</v-card-title
        >

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="amber" text @click="deleteItem">
            Delete
          </v-btn>
          <v-btn color="amber" text @click="closeDialog">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
const fb = require("@/firebaseConfig.js");
import { BottomNavigation } from "@/components/core";
import router from "@/router";
export default {
  name: "UserGroupsMenu",
  data() {
    return {
      items: [],
      cardId: null,
      dialog: false,
      collection: fb.groupsExCollection,
      returnRoute: "UserGroupsMenu",
    };
  },

  mounted() {
    this.init();
  },
  components: {
    BottomNavigation,
  },
  methods: {
    init() {
      fb.groupsExCollection
        .where("pid", "==", this.$route.params.id)
        .onSnapshot((querySnapshot) => {
          let items = [];
          querySnapshot.forEach((doc) => {
            let post = doc.data();
            items.push(post);
          });
          this.items = items;
        });
    },
    closeDialog() {
      this.cardId = null;
      this.dialog = false;
    },
    deleteRequest(id) {
      this.cardId = id;
      this.dialog = true;
    },
    deleteItem() {
      this.collection
        .doc(this.cardId)
        .delete()
        .then(() => {
          this.dialog = false;
          router.push({
            name: this.returnRoute,
          });
        })
        .catch((error) => {
          alert("Error removing document: ", error);
        });
    },
    editCard(id) {
      this.$router.push(`/users/project/${this.$route.params.id}/groups/${id}`);
    },
  },
};
</script>

<style lang="scss"></style>
